import * as globals from '@wandb/weave/common/css/globals.styles';
import {IconCheckmark} from '@wandb/weave/components/Icon';
import styled from 'styled-components';

export const MainContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const SelectionItemContainer = styled.div<{
  $selected?: boolean;
  $disabled?: boolean;
}>`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border: 2px solid ${p => (p.$selected ? globals.TEAL_350 : globals.MOON_50)};
  border-radius: 4px;
  background: ${globals.WHITE};
  padding: calc(${globals.spu} * 2);
  cursor: ${props => (props.$disabled ? 'not-allowed' : 'pointer')};
`;

export const Checkmark = styled(IconCheckmark)<{selected?: boolean}>`
  color: ${p => (p.selected ? globals.TEAL_600 : globals.MOON_350)};
  min-width: 32px;
  min-height: 32px;
`;

export const IconAndTextContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
`;

export const ItemLabel = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  font-size: 20px;
  font-weight: 600;
  line-height: 24px;
  letter-spacing: 0.2px;
`;

export const ItemDescription = styled.div`
  font-size: ${globals.fontSizeStandard};
  line-height: 24px;
`;

export const ItemLabelAndDescriptionContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
`;
